export default {
      id: "clipboard-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite-46b249.svg#clipboard-usage",
      toString: function () {
        return this.url;
      }
    }